// @flow

import * as React from 'react'
import Icon from './icon'
// import Swiper from 'react-id-swiper'
import ImageGallery from 'react-image-gallery'
import ClassNames from 'classnames'
import type {ProductMedia} from '../types'

type Props = {
  media: $ReadOnlyArray<ProductMedia>,
  onClose: () => void,
}

type State = {
  activeItemIdx: number,
}

class MediaViewer extends React.Component<Props, State> {
  state = {
    activeItemIdx: 0,
  }

  constructor(props: Props) {
    super(props)
  }

  renderSwiper() {
    const {media} = this.props
    const className = ClassNames('media-viewer-swiper')
    const images = media.map(item => ({
      original: item.sizes.medium,
      thumbnail: item.sizes.small,
    }))
    return (
      <div className={className}>
        <ImageGallery
          items={images}
          showThumbnails={true}
          showNav={true}
          showFullscreenButton={false}
          showPlayButton={false}
        />
      </div>
    )
  }

  render() {
    const {onClose, media} = this.props
    if (media.length == 0) {
      return null
    }
    return (
      <div className="media-viewer">
        <div className="media-viewer-backdrop" />
        <div className="media-viewer-wrapper">
          <div className="media-viewer-media">{this.renderSwiper()}</div>
          <button className="media-viewer-close" onClick={onClose}>
            <Icon name="icon-close" />
          </button>
        </div>
      </div>
    )
  }
}

export default MediaViewer
